<template>
  <div class="cps-main-page">
    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-select
            size="small"
            ref="selectGame"
            v-model="game"
            filterable
            remote
            reserve-keyword
            placeholder="游戏名称"
            @change="handleSelect($event,'query')"
            :remote-method="(query) => loadGame(query, 'query')"
            @visible-change="cancelReadOnly"
        >
          <el-option
              v-for="item in restaurants"
              :key="item.key"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select
            size="small"
            ref="selectUser"
            v-model="user"
            filterable
            remote
            reserve-keyword
            placeholder="用户名"
            @change="handleSelect2($event,'query')"
            :remote-method="(query) => loadUser(query, 'query')"
            @visible-change="cancelReadOnly"
        >
          <el-option
              v-for="item in restaurants2"
              :key="item.key"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" :loading="loading" @click="loadData(1)">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button type="warning" size="small" @click="openDrawer()">新增</el-button>
      </el-row>
      <el-table class="cps-table-data"
                :data="tableData"
                size="small"
                border
                v-loading="loading"
                :height="height"
                style="width: 100%"
                id="rebateSetTable">
        <el-table-column
            prop="game_name"
            width="150"
            label="游戏名">
        </el-table-column>
        <el-table-column
            prop="user_name"
            width="150"
            label="用户名">
        </el-table-column>
        <el-table-column
            prop="num"
            width="100"
            label="抽奖次数">
        </el-table-column>
        <el-table-column
            label="操作"
            width="150">
          <template v-slot="scope">
            <el-button type="text" size="mini" @click="addNum(scope.row.limit_id)">添加次数</el-button>
            <el-button type="text" size="mini" @click="deleteWelfare(scope.row.limit_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="cps-table-data"
                     @current-change="loadData"
                     background
                     :page-size="15"
                     :current-page="currentIndex"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
      <el-drawer
          title="添加记录"
          :visible.sync="showDrawer"
          direction="rtl">
        <div class="welfare-form">
          <el-form :model="form" :rules="rules" ref="form" label-width="100px" hide-required-asterisk>
            <el-form-item label="游戏名称" prop="game_id">
              <el-select
                  size="small"
                  ref="selectGame"
                  v-model="game"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="游戏名称"
                  @change="handleSelect($event, 'form')"
                  :remote-method="loadGame"
                  @visible-change="cancelReadOnly">
                <el-option
                    v-for="item in restaurants"
                    :key="item.key"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户名" prop="user_id">
              <el-select
                  size="small"
                  ref="selectGame"
                  v-model="user"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="用户名"
                  @change="handleSelect2($event, 'form')"
                  :remote-method="loadUser"
                  @visible-change="cancelReadOnly">
                <el-option
                    v-for="item in restaurants2"
                    :key="item.key"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="抽奖次数" prop="num">
              <el-input v-model="form.num" size="small" placeholder="抽奖次数"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :loading="submitting">保存</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import {
  addWelfareLimit,
  addWelfareLimitNum,
  deleteWelfareLimit,
  loadGame,
  loadUser,
  queryWelfareLimitList
} from "@/api/request";

export default {
  name: "welfareLimit",
  data() {
    return {
      queryField: {
        user_id: '',
        game_id: '',
      },
      restaurants: [],
      restaurants2: [],
      tableData: [],
      loading: false,
      height: window.innerHeight - 230,
      currentIndex: 1,
      total: 0,
      game: '',
      user: '',
      showDrawer: false,
      form: {
        user_id: '',
        game_id: '',
        num: ''
      },
      rules: {},
      submitting: false,
    }
  },
  mounted() {
    this.loadData(1);
  },
  methods: {
    loadData(index) {
      this.loading = true;
      let params = {
        pageNo: index,
        pageSize: 15,
        params: this.queryField
      }
      queryWelfareLimitList(params).then(res => {
        this.loading = false;
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
      })
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submitting = true;
          addWelfareLimit(this.form).then(res => {
            if(res.data.success) {
              this.$message.success('添加成功');
              this.cancel();
              this.loadData(this.currentIndex);
            }else {
              this.$message.error(res.data.error.message);
            }
          }).finally(() => {
            this.submitting = false;
          })
        }
      })
    },
    addNum(limitId) {
      this.$prompt('请输入抽奖次数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        let params = {
          limit_id: limitId,
          num: value,
        }
        addWelfareLimitNum(params).then(res => {
          if(res.data.success) {
            this.$message.success('添加成功');
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message);
          }
        })
      }).catch(() => {
      });
    },
    deleteWelfare(limitId) {
      this.$confirm('确定删除该记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteWelfareLimit(limitId).then(res => {
          if(res.data.success) {
            this.$message.success('删除成功');
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message);
          }
        })
      });
    },
    handleSelect(item, type){
      if(type === 'query') {
        this.queryField.game_id = item;
      }else if(type === 'form') {
        this.form.game_id = item;
      }
    },
    handleSelect2(item, type){
      if(type === 'query') {
        this.queryField.user_id = item;
      }else if(type === 'form') {
        this.form.user_id = item;
      }
    },
    loadGame(query, type){
      if (query !== '') {
        let me = this;
        loadGame(query).then(res => {
          me.restaurants = [];
          
          if(type === 'query') {
            let item = {};
            item.key = "-1";
            item.label = "全部";
            item.value = "";
            me.restaurants.push(item);
          }
          
          res.data.data.forEach(function (e) {
            let item = {}
            item.key = e.game_id
            item.value = e.game_id
            item.label = e.game_name
            me.restaurants.push(item)
          })
        })
      }
    },
    loadUser(query, type) {
      if (query !== '') {
        let me = this;
        loadUser(query).then(res => {
          me.restaurants2 = [];
          
          if(type === 'query') {
            let item = {};
            item.key = "-1";
            item.label = "全部";
            item.value = "";
            me.restaurants2.push(item);
          }
          
          res.data.data.forEach(function (e) {
            let item = {}
            item.key = e.user_id
            item.value = e.user_id
            item.label = e.user_name
            me.restaurants2.push(item)
          })
        })
      }
    },
    cancelReadOnly(value){
      this.$nextTick(() => {
        if (!value) {
          const {selectGame} = this.$refs;
          const input = selectGame.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          this.$refs.selectGame.blur();
        }
      });
    },
    reset() {
      this.queryField = {
        user_id: '',
        game_id: '',
      }
      this.game = '';
      this.user = '';
    },
    openDrawer() {
      this.showDrawer = true;
      this.reset();
      this.restaurants = [];
      this.restaurants2 = [];
    },
    cancel() {
      this.showDrawer = false;
      this.submitting = false;
      this.form = {
        user_id: '',
        game_id: '',
        num: ''
      }
      this.game = '';
      this.user = '';
      this.restaurants = [];
      this.restaurants2 = [];
    }
  }
}
</script>

<style scoped>
/deep/ .welfare-form .el-input__inner {
  width: 300px;
} 
</style>